export type FieldConfig = {
  label: string;
  type?: 'string' | 'number' | 'date' | 'boolean' | 'object';
  formatValue?: (value: any, fieldName: string) => string;
  mapValue?: (formValue: any, row: any) => any;
  excludeFromComparison?: boolean;
};

export type WizardConfig = {
  fields: Record<string, FieldConfig>;
  getRowDisplayName?: (row: any) => string;
  excludeKeys?: string[];
};

export const defaultWizardConfig: WizardConfig = {
  fields: {},
  excludeKeys: ['id'],
};
